import { GetPrograms, UserData } from 'models/user';
import { Dispatch } from 'redux';
import utils from 'utils';

import { slice } from './slice';

export const transformAndSetMenuPrograms = (menuData: GetPrograms) => (dispatch: Dispatch) => {
  const menu = utils.app.orderMenuItems(menuData.programs[0].children);
  dispatch(slice.actions.setMenuPrograms(menu));
};

export const performUserLogin = (userData: UserData) => (dispatch: Dispatch) => {
  dispatch(slice.actions.setAuthData(userData));
  dispatch(slice.actions.setUserAuthStatus(true));
};

const userActions = {
  ...slice.actions,
  transformAndSetMenuPrograms,
  performUserLogin,
};

export default userActions;
